export const IMAGE_SIZE = 96
export const IMAGE_ASPECT_RATIO = 4 / 3
export const CHANNEL = 'Channel'
export const MAKE = 'Make'
